import Backdrop from '@mui/material/Backdrop';
import { styled } from '@mui/material/styles';

export const BackdropStyled = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff',
}));
